import { CookieAccessor } from '../Customers/UserProfile/Components/CookiesConsent/CookieAccessor';
import { CookieNamesViewModel } from '../Layouts/Partial/CookieNamesViewModel.csharp';

declare let cookieNames: CookieNamesViewModel;

export class TrackingAccessor {
    public static get isMarketingEnabled(): boolean {
        return !!CookieAccessor.getCookie(cookieNames.tracking.marketing);
    }

    public static get isPreferencesEnabled(): boolean {
        return !!CookieAccessor.getCookie(cookieNames.tracking.preferences);
    }

    public static get isStatisticsEnabled(): boolean {
        return !!CookieAccessor.getCookie(cookieNames.tracking.statistics);
    }
}
